export const productCategoryItemAbonnementProps = () => ({
  article: {
    type: Object,
    required: true
  },
  cartContext: {
    type: String,
    required: false
  },
  index: {
    type: Number,
    required: false
  }
});

export const useProductCategoryItemAbonnement = (props) => {
  const prix = computed(() => {
    return parseFloat(props.article.prix);
  })

  return { prix }
}